import React from 'react';

import {assert} from 'Asserts';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import runModal from 'ui-library/runModal';

interface EditConfirmationInfo {
  actionText?: string;
  confirmationText?: string;
  title: string;
  warnings: Array<string>;
}

interface BulkAssemblyEditConfirmationModalProps extends EditConfirmationInfo {
  onRequestClose: () => void;
  onRequestSubmit: (confirmed: boolean) => void;
}

/**
 * Modal to warn and confirm assembly changes that will have side effects.
 */
export default function BulkAssemblyEditConfirmationModal({
  actionText,
  confirmationText,
  title,
  warnings,
  onRequestSubmit,
  onRequestClose,
}: BulkAssemblyEditConfirmationModalProps): JSX.Element {
  assert(warnings.length > 0, 'Expected at least one warning');
  return (
    <Modal
      onRequestClose={onRequestClose}
      buttons={[
        {text: 'Cancel', cancel: true, style: ButtonStyle.TERTIARY_GRAY, onClick: onRequestClose},
        {
          text: confirmationText ?? 'Continue',
          submit: true,
          style: ButtonStyle.NEGATIVE,
          onClick: () => {
            onRequestSubmit(true);
          },
        },
      ]}
      title={title}
    >
      <div>
        {/* Currently, there is only one possible warning. In the future we can display multiple
        warnings in a list. */}
        <p>{warnings[0]}</p>
        {actionText && <p>{actionText}</p>}
      </div>
    </Modal>
  );
}

export async function withEditConfirmation({
  onConfirm,
  title,
  warnings,
}: EditConfirmationInfo & {onConfirm: () => void}): Promise<void> {
  const wasConfirmed = await runModal(BulkAssemblyEditConfirmationModal, {
    title,
    warnings,
  });
  if (wasConfirmed) {
    onConfirm();
  }
}
